import React from 'react'
import { DateField, IconButton, RadioGroup } from 'vnetwork-ui'
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form'
import {
    DayOffNewPayload,
    DayOffRangeTime,
} from '@/modules/Dayoffs/types/payload'
import toast from 'react-hot-toast'
import { DayOffResponse } from '@/modules/Dayoffs/types/response'
import dayjs from 'dayjs'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import { useTranslation } from 'react-i18next'

interface RangeTimeItemProps {
    className?: string
    position: number
    setValue: UseFormSetValue<DayOffNewPayload>
    watch: UseFormGetValues<DayOffNewPayload>
    dayOff: DayOffResponse | null
    pageType: 'create' | 'update'
    removeRangeTime: (index: number) => void
    calDayOffLeftEmployee: () => number
    item: DayOffRangeTime
    setRangeTimeRendered: React.Dispatch<React.SetStateAction<boolean>>
    rangeTimeRendered: boolean
    minDate?: dayjs.Dayjs
}
const RangeTimeItem: React.FC<RangeTimeItemProps> = ({
    className,
    position,
    setValue,
    watch,
    dayOff,
    pageType,
    removeRangeTime,
    item,
    calDayOffLeftEmployee,
    rangeTimeRendered,
    setRangeTimeRendered,
    minDate,
}) => {
    const { t: translate } = useTranslation()
    const [ready, setReady] = React.useState(false)
    React.useEffect(() => {
        let timer: NodeJS.Timeout
        if (pageType === 'update' && !rangeTimeRendered) {
            timer = setTimeout(() => setReady(true), 50 * position)
        }
        return () => clearTimeout(timer)
    }, [position])
    if (pageType === 'update' && !rangeTimeRendered && !ready) return null
    return (
        <div
            id="day-off-range"
            className={className}
            onAnimationEnd={() => {
                if (position === watch('day_off.day_off_range_time').length - 1)
                    setRangeTimeRendered(true)
            }}
        >
            <div className="hidden lg:block col-span-1" />
            <div className="m-2 col-span-1">
                <DateField
                    disabled={
                        pageType !== 'create' &&
                        dayOff?.day_off_status !== 'pending'
                    }
                    minDate={minDate}
                    value={
                        item?.start_day_off
                            ? dayjs(item.start_day_off)
                            : undefined
                    }
                    onChange={(e) => {
                        const list = watch('day_off.day_off_range_time')?.map(
                            (child) =>
                                dayjs(child?.start_day_off)?.format(
                                    'YYYY-MM-DD'
                                )
                        )
                        if (!list?.includes(e?.format('YYYY-MM-DD') || '')) {
                            setValue(
                                `day_off.day_off_range_time.${position}.start_day_off`,
                                e?.format('YYYY-MM-DD').toString() || ''
                            )
                        } else {
                            toast.error('Date already exists')
                        }
                    }}
                />
            </div>
            {/* {watch('day_off.day_off_range_time').length > 1 && (
                <IconButton
                    className={`col-span-1 block lg:hidden rounded-full m-2 justify-end`}
                    onClick={() => {
                        if (
                            pageType === 'create' ||
                            dayOff?.day_off_status === 'pending'
                        )
                            removeRangeTime(position)
                    }}
                >
                    <DeleteOutlineIcons className="text-red-500" />
                </IconButton>
            )} */}
            <div className="col-span-6 lg:col-span-3 w-full flex lg:px-2">
                <RadioGroup
                    direction="row"
                    value={item?.day_off_option}
                    onChange={(e) => {
                        if (
                            watch('day_off.day_off_type') === 'annual_leave' &&
                            [0, 1].includes(
                                watch(
                                    `day_off.day_off_range_time.${position}.day_off_option`
                                )
                            ) &&
                            Number(e) === 2
                        ) {
                            if (calDayOffLeftEmployee() - 0.5 < 0) {
                                toast.error('No more day off left')
                                return
                            }
                        }
                        setValue(
                            `day_off.day_off_range_time.${position}.day_off_option`,
                            Number(e) || 0
                        )
                    }}
                    disabled={
                        pageType !== 'create' &&
                        dayOff?.day_off_status !== 'pending'
                    }
                    options={[
                        {
                            label: translate('all_day'),
                            value: 2,
                            disabled:
                                watch('day_off.day_off_type') ===
                                    'annual_leave' &&
                                calDayOffLeftEmployee() <= 0,
                        },
                        {
                            label: translate('morning'),
                            value: 0,
                        },
                        {
                            label: translate('afternoon'),
                            value: 1,
                        },
                    ]}
                />
                {watch('day_off.day_off_range_time').length > 1 && (
                    <div className="lg:col-span-1 flex justify-end items-center ml-auto mt-2">
                        <IconButton
                            className={``}
                            onClick={() => {
                                if (
                                    pageType === 'create' ||
                                    dayOff?.day_off_status === 'pending'
                                )
                                    removeRangeTime(position)
                            }}
                        >
                            <DeleteOutlineIcons className="text-gray-400" />
                        </IconButton>
                    </div>
                )}
            </div>
        </div>
    )
}
export default RangeTimeItem
